// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uTyA5vJvNGQpng {
  font-weight: var(--ds-font-weight-bold, bold);
}
.tHvPSDDr1tJ1wk {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
}
`, ""]);
// Exports
export var shortcodes = `uTyA5vJvNGQpng`;
export var name = `tHvPSDDr1tJ1wk`;
export default ___CSS_LOADER_EXPORT___;
